import React, { useContext } from 'react';
import _ from "lodash";
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import { Tooltip, Row, Col, Button, Card, Progress } from 'antd';
import { ArrowRightOutlined, LoadingOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import ProductPageConstants from './ProductPageConstants.js';
import AiProductBadge from '../AiProduct/AiProductBadge';
import ENVIRONMENT from '../../../../environments';

const conicColors = {
    '0%': '#7883DC',
    '50%': '#276DD7',
    '100%': '#91D5FF',
};

const FeatureProductImages = () => {
    const { heroShot, statusOf360Spin, statusOfMp4Video, secondaryShots, productImageCount, openProductAssetViewer,
        setSelectedAsset, setSelectedProductImage, allProductImages, setImgAccessedFromCarousel, setSelectedImgFilename,
    setSelectedImgOriginalFormat, isAiModel, modelStatus, aiModelProgressMessage, aiModelProgressPercentage, product_id,
    setSelectedImage, setSelectedImageResolution, setSelectedImageFormat, setSelectedImageName, setSelectedImageCapturedBy,
    setSelectedImageCreationDate, setSelectedImageType, setSelectedFilenameWithExtension, setOpenAllTab, hasUSDZ,
    selectedProductImage, setViewing3D, aiModelJobStatus, productData, aiInputImage, isAiGlbExists, hasGlb, setViewingAiModel } = useContext(CustomerProductContext);

    const policy = "always-allow";
    let loaderProps = {};
    loaderProps = {
        loading: "eager",
    };
    
    const selectAssetAndOpenViewer = (asset, image = heroShot, open = false) => {
        setOpenAllTab(open);
        if (asset == "images") {
            setViewing3D(false);
            
            if (isAiModel) {
                setSelectedAsset("all");
                if (hasGlb() && open) {
                    setViewing3D(true);
                    if (isAiModel) {
                        setViewingAiModel(true);
                    }
                }
            } else {
                setSelectedAsset(asset);
            }
            
            if (image) {
                let selected_image = image;
                let image_index = allProductImages.findIndex(img => img.url == selected_image);
                if (image == heroShot && isAiModel) {
                    image_index = 0;
                    setSelectedProductImage(allProductImages[image_index]?.url);
                } else {
                    setSelectedProductImage(selected_image);
                }
                setSelectedImgOriginalFormat(allProductImages[image_index]?.format);
                setSelectedImgFilename(allProductImages[image_index]?.filename);
                setSelectedImage(allProductImages[image_index]);
                setSelectedImageResolution(allProductImages[image_index]?.resolution);
                setSelectedImageFormat(allProductImages[image_index]?.format);
                setSelectedImageName(allProductImages[image_index]?.display_name);
                setSelectedImageCapturedBy(allProductImages[image_index]?.captured_by)
                setSelectedImageCreationDate(allProductImages[image_index]?.created_at);
                setSelectedImageType(allProductImages[image_index]?.main_type)
                setSelectedFilenameWithExtension(allProductImages[image_index]?.filename)
            }

            setImgAccessedFromCarousel(false);
            openProductAssetViewer();
        } else {
            openProductAssetViewer();
            setSelectedAsset(asset);
            
            if (isAiGlbExists && modelStatus == 16 && asset == '3d_preview') {
                setSelectedAsset("ai_model");
            } else if (asset == "all" && isAiModel == false && open) {
                setViewing3D(true);
            } else {
                if (!selectedProductImage) {
                    if (hasGlb() && asset == 'all' && open) {
                        setViewing3D(true);
                        if (isAiModel) {
                            setViewingAiModel(true);
                        }
                    } else if (allProductImages?.length > 0) {
                        setViewing3D(false);
                        setImageDetails(allProductImages[0])
                    }
                }
            }
        }
    }

    const setImageDetails = (image) => {
        setSelectedImage(image);
        setSelectedProductImage(image.url);
        setSelectedImgOriginalFormat(image.format);
        setSelectedImgFilename(image.filename);
        setSelectedImageResolution(image.resolution);
        setSelectedImageFormat(image.format);
        setSelectedImageName(image.display_name);
        setSelectedImageCapturedBy(image.captured_by)
        setSelectedImageCreationDate(image.created_at);
        setSelectedImageType(image.main_type)
        setSelectedFilenameWithExtension(image.filename)
    };


    const getFormat = (displayed_image = heroShot) => {
        let image = allProductImages.filter(img => img.url === displayed_image);
        let type = "";
        if (image.length > 0) {
            type = image[0].type;
        }

        return type;
    }

    return (
        <Col className="frame" span={12}>
            {(!isAiModel || modelStatus == 5) ?
            <Card className="image-viewer">
                <Tooltip title={<span className='manrope f-12 white'>Expand image</span>} placement="left">
                    <img src={"/img/fullScreenIcon.jpg"}
                        alt="expand image"
                        className="expand-icon-pos" onClick={() => { selectAssetAndOpenViewer("images", heroShot, true) }} />
                </Tooltip>
                <div className='hero-shot-label'>
                    <div className='manrope f-14 black-26 lh-28'>{ProductPageConstants.IMAGE_TYPES[getFormat()]}</div>
                </div>
                {isAiModel && modelStatus != 5 &&
                    <div>
                        <AiProductBadge isAbsolute={true} />
                    </div>
                }
                    {((isAiModel || hasUSDZ()) && !productData?.user_usecase?.includes('high_res') && !productData?.user_usecase?.includes('high_pbr')) && hasGlb() ?
                    
                        <div className="ai-model-loader" style={{ cursor: 'pointer' }}>
                            <model-viewer
                                environment-image="neutral"
                                class="disablehover ai-model-viewer"
                                style={{ width: '100vw', height: '100%', minHeight: '520px', display: 'block' }}
                                {...loaderProps}
                                ar
                                data-js-focus-visible
                                shadow-intensity={1}
                                interaction-policy={policy}
                                src={ENVIRONMENT.getBaseURL() +
                                    `product_assets/glb/${product_id}.glb`
                                }
                                alt="3D Model"
                                camera-controls
                                disable-tap
                                reveal="auto"
                                background-color="#FFFFFF"
                            >
                            </model-viewer>
                        </div>
                :
                <img className="hero-shot" alt="Hero Shot" src={heroShot} onClick={() => { selectAssetAndOpenViewer("images", heroShot) }} />}

                <div className='product-action-bar'>
                    {ProductPageConstants.PRODUCT_ACTIONS.map((action, index) => (
                        ((statusOf360Spin == "" && action.type == "360_view" ) || (statusOfMp4Video == "" && action.type == "mp4_video")) ? "" :
                            <Tooltip title={action.tooltip} placement="top" >
                                <Card className='product-action-menu-card' key={index} onClick={() => { selectAssetAndOpenViewer(action.type) }}>
                                    <img src={action.icon} className='product-action-img' />
                                </Card>
                            </Tooltip>
                    ))}
                </div>
            </Card>:
            <>
                {
                (modelStatus == 13) ?
                    <div className="ai-model-loader">
                        <div className='ai-model-loader-content'>
                            {aiModelJobStatus == 'failed' ? 
                                <ExclamationCircleOutlined className='ai-image-loader' style={{fontSize: 24}} />

                            :
                                <LoadingOutlined className='ai-image-loader' style={{marginTop: 0}} />
                            }
                        </div>
                        
                    </div>
                    :
                        isAiGlbExists && secondaryShots.length <= 0 ? 
                        <div  className="ai-model-loader">
                            <model-viewer
                                environment-image="neutral"
                                class={"disablehover ai-model-viewer"}
                                style={{width: '100%', height: '100%'}}
                                {...loaderProps}
                                ar
                                data-js-focus-visible
                                shadow-intensity={1}
                                interaction-policy={policy}
                                src={ ENVIRONMENT.getBaseURL() +
                                `product_assets/ai_generated_glb/${product_id}.glb`
                                }
                                alt="3D Model"
                                camera-controls
                                disable-tap
                                // interaction-prompt="none"
                                background-color="#FFFFFF"
                            >
                            </model-viewer>
                            <div>
                                <AiProductBadge isAbsolute={true} />
                            </div>
                        </div>
                        :
                        <div  className="ai-model-loader">
                            <div style={{display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center'}}>
                                <img className='ai-model-viewer' src={aiInputImage} alt="AI Input Image" />
                            </div>
                            {isAiGlbExists &&
                                <div className='product-action-bar' style={{bottom: 300, zIndex: 999}}>
                                    <Tooltip title='3D Preview' placement="top" >
                                        <Card className='product-action-menu-card' key={1} onClick={() => { selectAssetAndOpenViewer('3d_preview') }}>
                                            <img src='/img/3d.jpg' className='product-action-img' />
                                        </Card>
                                    </Tooltip>
                                </div>
                            }
                            <div>
                                <AiProductBadge isAbsolute={true} transparent={true} />
                            </div>
                            <div className='hero-shot-label' style={{left: '90px'}}>
                                <div className='manrope f-14 black-26 lh-28'>Product Reference</div>
                            </div>
                            
                            {(!isAiModel) || (isAiModel && (modelStatus === 16 || modelStatus === 5)) ?
                                <>
                                    <Tooltip title={<span className='manrope f-12 white'>Expand</span>} placement="left">
                                        <img src={"/img/fullScreenIcon.jpg"}
                                            alt="expand image"
                                            className="expand-icon-pos" onClick={() => {
                                                selectAssetAndOpenViewer("all") 
                                                 }} />
                                    </Tooltip>
                                </> 
                            : ''}
                        </div>
                    
                }
            </>
            }

            <Row className="w-100">
                {((modelStatus == 13 || modelStatus == 14 || modelStatus == 15) && !ENVIRONMENT.COMPANY_IDS_WITH_CUSTOM_AI_OUTPUTS.includes(localStorage.getItem("company_id"))) ?
                <Col span={24} className='display-flex j-s-b a-c gg-16 w-100'>
                    <Card className="image-card" key={1}>
                        <div className='secondary-shot'>
                            {aiModelJobStatus == 'failed' ?
                                <ExclamationCircleOutlined className='ai-image-loader' style={{fontSize: 24}} />
                                :
                                <LoadingOutlined className='ai-image-loader' />
                            }
                        </div>
                    </Card>
                    <Card className="image-card" key={2}>
                        <div className='secondary-shot'>
                            {aiModelJobStatus == 'failed' ?
                                <ExclamationCircleOutlined className='ai-image-loader' style={{fontSize: 24}} />
                                :
                                <LoadingOutlined className='ai-image-loader' />
                            }
                        </div>
                    </Card>
                    <Card className="image-card" key={3}>
                        <div className='secondary-shot'>
                            {aiModelJobStatus == 'failed' ?
                                <ExclamationCircleOutlined className='ai-image-loader' style={{fontSize: 24}} />
                                :
                                <LoadingOutlined className='ai-image-loader' />
                            }
                        </div>
                    </Card>
                </Col>
                :
                <Col span={24} className='display-flex j-s-b a-c gg-16 w-100' style={{zIndex: 3}}>
                    {secondaryShots.slice(0, 3).map((image, index) => (
                        <Card className="image-card" key={index}>
                            <img className="secondary-shot" alt={"Shot_" + index}
                                onClick={() => { selectAssetAndOpenViewer("images", image) }}
                                src={image} />
                        </Card>
                    ))}
                </Col>
                }
            </Row>
            {(!isAiModel) || (isAiModel && (modelStatus === 16 || modelStatus === 5)) ?
            <Button className="button" onClick={() => { selectAssetAndOpenViewer("images", heroShot, true) }}>
                <div className="text">See All {productImageCount} Assets</div>
                <ArrowRightOutlined className="arrow-right" />
            </Button>
            : ''}
        </Col>
    )
}

export default FeatureProductImages;